<template>
  <SmallSquare class="m-b-25 m-t-10" content='查看会员的包邮卡领取及使用情况，包括领取的包邮卡编码、领取时间、过期时间级是否已使用等情况。默认显示最近30天数据
  可通过搜索查询任意30天内的数据。'></SmallSquare>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf">
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item class='mb15' label="包邮卡编码" name='id'>
            <a-input v-model:value="search.id" style="width:200px" placeholder="请输入包邮卡编码进行搜索"/>
        </a-form-item>
        <a-form-item class='mb15' label="微信昵称" name='member_name'>
          <a-input v-model:value="search.member_name" style="width:200px" placeholder="请输入微信昵称进行搜索"/>
      </a-form-item>
        <a-form-item label="状态" name='status'>
          <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">未使用</a-select-option>
            <a-select-option :value="1">已使用</a-select-option>
            <a-select-option :value="0">已过期</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="领取时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="过期时间" name='times'>
          <a-range-picker v-model:value="times" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <router-link :to="'/agent/agent_level/detail?type=look&id='+record.id">
            <a href="javascript:;">详情</a>
          </router-link>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getParcelUseList } from "@/api/assets";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  id: "",
  status: '',
  page: 1,
  limit: 10,
  start_time:'',
  end_time:'',
  member_name:'',
  expire_start_time:'',
  expire_end_time:''
};
export default {
  cardList:'cardUsedList',
  components: {  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      time:[],
      times:[],
      total: 1
    });
    let columns = [
      {
        title: "包邮卡编码",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "领取时间",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "过期时间",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "来源备注",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "领取人昵称",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "状态",
        dataIndex: "signing_time",
        key: "signing_time",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject('$router')
    const $Modal = inject('$Modal')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getParcelUseList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange
      
    };
  },
};
</script>